import { useReadMonitorCurrentlaunchStatus } from 'shared/hooks/useReadMonitorCurrentlaunchStatus'
import { usePrevious } from '../usePrevious'

interface SetReadSpyCurrentLaunchDecoratorParamsModel{
    spyId: number
}

interface SetReadSpyCurrentLaunchDecoratorOptionsModel{
    skip: boolean
}

interface UseReadSpyCurrentLaunchDecoratorResultModel{
    data: any,
    previousData: any,
    setParams: any,
    setOptions: any
}

export const useReadSpyCurrentLaunchDecorator = (): UseReadSpyCurrentLaunchDecoratorResultModel => {
    const {
        data: spyCurrentlaunchStatus,
        setParams: setUseReadMonitorCurrentlaunchStatusParams,
        setOptions: setUseReadMonitorCurrentlaunchStatusOptions,
    } = useReadMonitorCurrentlaunchStatus()

    const previousData = usePrevious(spyCurrentlaunchStatus)

    
    const setReadSpyCurrentLaunchDecoratorParams = (params: SetReadSpyCurrentLaunchDecoratorParamsModel) => {
        setUseReadMonitorCurrentlaunchStatusParams({
            monitorId: params.spyId
        })
    }

    const setReadSpyCurrentLaunchDecoratorOptions = (options: SetReadSpyCurrentLaunchDecoratorOptionsModel) => {
        setUseReadMonitorCurrentlaunchStatusOptions((prev: any) => {
            return {
                ...prev,
                skip: options.skip
            }
        })
    }

    return {
        data: spyCurrentlaunchStatus,
        previousData,
        setParams: setReadSpyCurrentLaunchDecoratorParams,
        setOptions: setReadSpyCurrentLaunchDecoratorOptions
    }
}